/**
 * Single source of truth for the Atlas EULA — version metadata, contact
 * addresses, and effective dates. Both the public legal page
 * (src/pages/legal/EulaPage.tsx) and the click-through acceptance gate
 * (src/pages/legal/EulaAcceptPage.tsx) import from here.
 *
 * Bump CURRENT_EULA_VERSION whenever the substantive terms change. The
 * authenticated gate (src/app/RequireEulaAcceptance.tsx) compares the user's
 * most recent acceptance against this constant; any mismatch forces them
 * back through the click-through flow before they can re-enter the app.
 *
 * Past versions must NOT be deleted from this file's history — the audit
 * trail in public.eula_acceptances stores the version string the user
 * actually accepted, and an auditor must be able to trace each version
 * string back to the exact text that was on screen at acceptance time.
 */

export const CURRENT_EULA_VERSION = 'v1.0';

/**
 * Date the CURRENT_EULA_VERSION came into force. Stored on each acceptance
 * row so we can later answer "which dated text did this user accept?"
 * without having to git-blame the React component.
 */
export const CURRENT_EULA_EFFECTIVE_DATE = '2026-05-08';

/**
 * Human-readable display for the effective date. Kept in sync with
 * CURRENT_EULA_EFFECTIVE_DATE; only used for UI rendering.
 */
export const CURRENT_EULA_EFFECTIVE_DATE_DISPLAY = 'May 8, 2026';

/**
 * Last time the document text on the public page was edited (typo fixes,
 * formatting, etc.). For substantive changes, also bump
 * CURRENT_EULA_VERSION + CURRENT_EULA_EFFECTIVE_DATE.
 */
export const CURRENT_EULA_LAST_UPDATED_DISPLAY = 'May 8, 2026';

export const VIRRO_LEGAL_EMAIL = 'Legal@virrolife.com';
export const VIRRO_SYSTEM_ADMIN_EMAIL = 'legal@virrolife.com';

/**
 * Lowercase form for `mailto:` and other case-sensitive contexts. RFC 5321
 * makes the local-part case-sensitive in principle but virtually all
 * receivers normalize, and lowercase is the safe canonical form for links.
 */
export const VIRRO_LEGAL_EMAIL_HREF = VIRRO_LEGAL_EMAIL.toLowerCase();
export const VIRRO_SYSTEM_ADMIN_EMAIL_HREF = VIRRO_SYSTEM_ADMIN_EMAIL.toLowerCase();
